import { NgModule } from '@angular/core';
import { FullUrlPipe } from './full-url.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { ReplacePipe } from './replace.pipe';

// RESOURCE: http://stackoverflow.com/questions/39007130/the-pipe-could-not-be-found-angular2-custom-pipe
@NgModule({
  imports: [],
  providers: [],
  declarations: [
    FullUrlPipe,
    SafeHtmlPipe,
    ReplacePipe,
  ],
  exports: [
    FullUrlPipe,
    SafeHtmlPipe,
    ReplacePipe
  ]
})
export class CustomPipesModule { }
